// Self-reference so the bundler resolves the impl through this package's
// `exports` map (react-server -> server, default -> browser). A relative
// import would bypass the conditional exports map and resolve to the
// type-only stub in ./impl/index.ts instead.
// eslint-disable-next-line import/no-extraneous-dependencies, local-rules/no-self-package-import
import { BATCH_DELAY_MS, MAX_BATCH_SIZE, sendLogs } from '@frameio/flog/impl';

const PENDING: { message: string; data: object }[] = [];

export function sink(message: string, ...props: object[]) {
  const data = Object.assign({}, ...props);
  PENDING.push({ message, data });
  scheduleFlush();
}

export async function flush(): Promise<number> {
  if (pendingFlush) {
    clearTimeout(pendingFlush);
    pendingFlush = null;
  }
  let flushed = 0;
  while (PENDING.length) {
    const body = PENDING.splice(0, Math.min(MAX_BATCH_SIZE, PENDING.length));
    // eslint-disable-next-line no-await-in-loop
    await sendLogs(body);
    flushed += body.length;
  }
  return flushed;
}

let pendingFlush: NodeJS.Timeout | null = null;
function scheduleFlush() {
  if (!pendingFlush) {
    pendingFlush = setTimeout(flush, BATCH_DELAY_MS);
  }
}
